import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Navbar as ReactNavbar, Container, Nav} from 'react-bootstrap';
import { useLocation } from 'react-router-dom'
import { store, StateProvider } from '../Store';

export default function NavBar() {

  const { state, dispatch } = useContext(store);
  const currentLocation = useLocation();

  const styleTheme = {
    'navbar': `${state?.configData && state.configData.theme}-navbar`,
    'active': `${state?.configData && state.configData.theme}-active`
  }

  return (
    <>
    <div className={ "odisea-page-navbar " + styleTheme.navbar}>
    <ReactNavbar bg="dark" variant="dark">
      <Nav className={ "odisea-page-navbar " + styleTheme.navbar}>
        <Link to='/'>Home</Link>
        <Link to='/migration' className={currentLocation.pathname === '/migration' && 'active ' + styleTheme.active}>Migración</Link>
        <Link to="/mobility" className={currentLocation.pathname === '/mobility' && 'active ' + styleTheme.active}>Movilidad</Link>
        <Link to='/segregation' className={currentLocation.pathname === '/segregation' && 'active ' + styleTheme.active}>Segregación</Link>
        {state.configData.enabledObservatory === 'true' &&
          <Link to='/observatory' className={currentLocation.pathname.includes('/observatory') && 'active ' + styleTheme.active}>Observatorio</Link>
        }
      </Nav>
    </ReactNavbar>
    </div>
    </>
  )

}
